var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSelectNoneHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_select_none_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Windows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-spaces-Copy",
    transform: "translate(-788.000000, -933.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_select_none_hover",
    transform: "translate(788.000000, 933.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    fill: "#E5E5E5",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    fillOpacity: 0,
    fill: "#D1BFFC",
    opacity: 0.488606771,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#B6B6B6",
    cx: 8.5,
    cy: 8.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#B6B6B6",
    cx: 15.5,
    cy: 8.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#B6B6B6",
    cx: 15.5,
    cy: 15.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "#B6B6B6",
    cx: 8.5,
    cy: 15.5,
    r: 2.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectNoneHover);
export default __webpack_public_path__ + "static/media/icon_select_none_hover.3ea3a2fd0e5d14d8b526b0c1291bb4ae.svg";
export { ForwardRef as ReactComponent };